import { Container } from '@/components/ui/template/Container'
import AnchorTag from '../../../components/AnchorTag'
import { SlideIn } from '../../../components/ui/transitions/SlideIn'
import { useWindowSize } from '@/hooks/helpers/useWindowSize'
import { Strong } from '@/components/ui/Strong'
import { AddPepperToken } from '@/components/nav-bar/AddPepperToken'

const WhatIsPepperSection = () => {
	const { isMobile } = useWindowSize()

	return (
		<Container className="bg-green-10">
			<Container.Content className="flex flex-col md:flex-row justify-between items-center gap-10 pb-10 overflow-hidden">
				<SlideIn from={isMobile ? 'top' : 'right'} className="md:order-2">
					<img
						src="/images/harvest-mechanics.webp"
						alt="What Is Pepper?"
						className="max-w-[160px] md:max-w-[210px] aspect-square object-contain"
						loading="lazy"
					/>
				</SlideIn>
				<SlideIn from={isMobile ? 'bottom' : 'left'} className="flex flex-col gap-10 md:gap-6 md:order-1">
					<h2 className="uppercase text-[5rem] md:text-[5rem] text-neutral-100 font-bold text-center md:text-left leading-none">
						What is PEPPER?
					</h2>
					<p className="text-neutral-40 text-[1.5rem] leading-[26px]">
						PEPPER is a new community token built on the Chiliz Chain{' '}
						<Strong>with a max supply of 8,888,888,888,000,000 PEPPER</Strong>. Its purpose and utility are
						still a bit of a mystery—created for the community to take the reins and ride with it! For the
						full scoop (or should we say spice), be sure to check out the Whitepepper and follow{' '}
						<AnchorTag text="Pepper" /> on social media for the latest updates.
					</p>
					{!isMobile ? <AddPepperToken className="md:self-start" /> : <></>}
				</SlideIn>
			</Container.Content>
		</Container>
	)
}

export default WhatIsPepperSection
